import { useTranslation } from 'react-i18next'
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog'
import { Badge } from '@/components/ui/badge'
import type { User } from '@/types/entities'

interface UserTeamsDialogProps {
    open: boolean
    onOpenChange: (open: boolean) => void
    user: User | null
}

export function UserTeamsDialog({ open, onOpenChange, user }: UserTeamsDialogProps) {
    const { t } = useTranslation()
    if (!user) return null

    const teams = user.teams || []

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[500px]">
                <DialogHeader>
                    <DialogTitle>{t('users.userTeams')}</DialogTitle>
                    <DialogDescription>
                        {t('users.userTeamsDescription', { name: user.name })}
                    </DialogDescription>
                </DialogHeader>

                <div className="space-y-4 py-4">
                    {teams.length === 0 ? (
                        <p className="text-sm text-muted-foreground">{t('users.noTeams')}</p>
                    ) : (
                        <div className="space-y-2">
                            {teams.map((team) => (
                                <div
                                    key={team.id}
                                    className="flex items-center justify-between rounded-lg border p-3"
                                >
                                    <div>
                                        <p className="font-medium">{team.teamName}</p>
                                        {team.description && (
                                            <p className="text-sm text-muted-foreground">{team.description}</p>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </DialogContent>
        </Dialog>
    )
}
